export default "__VITE_ASSET__ee87494b__"